export const RATE_LIMIT = 3;
export const RATE_WINDOW_MS = 30 * 24 * 60 * 60 * 1000;

const keyFor = (email) => `c21:rate:${String(email).trim().toLowerCase()}`;

export function getAttempts(email) {
  if (!email || typeof localStorage === 'undefined') return [];
  try {
    const raw = localStorage.getItem(keyFor(email));
    const now = Date.now();
    return (raw ? JSON.parse(raw) : []).filter((t) => now - t < RATE_WINDOW_MS);
  } catch {
    return [];
  }
}

export function hasReachedLimit(email) {
  return getAttempts(email).length >= RATE_LIMIT;
}

export function recordAttempt(email) {
  if (!email || typeof localStorage === 'undefined') return;
  const attempts = getAttempts(email);
  attempts.push(Date.now());
  try {
    localStorage.setItem(keyFor(email), JSON.stringify(attempts));
  } catch {
    // Storage full or unavailable — silently ignore
  }
}
